import React, { useEffect } from "react";
import Graph from '../../components/Graph';
import Table from 'react-bootstrap/Table';
import Spinner from 'react-bootstrap/Spinner';
import moment from 'moment';

const VehCounts = (props) => {
      
    const {
        isLoadingCounts,
        pedTotalCount,
        bikeTotalCount,
        vehTotalCount,
        vehicleCount,
        options,
        assetName,
        vehicleCountTbl,
        counts,
        setVehicleCountTbl,
        setPedTotalCount,
        setVehTotalCount,
        setBikeTotalCount,
        setVehicleCount,
        chartColors
     } = props


    // VEHICLE COUNT START
    // --------------------------
    useEffect(() => {
        // Total vehicles count / hour
        const getVehicleCount = () => {

            let countVh = [];
            let arrPed = [];
            let arrVeh = [];
            let arrBike = [];


            for (let hh = 0; hh < 24; hh++){

                let dataHour = counts.filter(function(item){
                    let aDate = moment(new Date(item.date_iso)).format('HH');
                    return parseInt(aDate) === hh;
                })

                let ped = 0;
                let bike = 0;
                let veh = 0;

                // Agregate VOLUME by CLASS
                for (let x = 0; x < dataHour.length; x++){
                     ped += dataHour[x].entries.filter(item => {return item.CLASS === 'PEDESTRIAN' }).reduce((sum, item) => {return sum = sum + (parseInt(item.VOLUME) || 0) }, 0);
                     veh += dataHour[x].entries.filter(item => {return item.CLASS !== 'PEDESTRIAN' && item.CLASS !== 'BIKE' }).reduce((sum, item) => {return sum = sum + (parseInt(item.VOLUME) || 0) }, 0);
                     bike += dataHour[x].entries.filter(item => {return item.CLASS === 'BIKE' }).reduce((sum, item) => {return sum = sum + (parseInt(item.VOLUME) || 0) }, 0);
                }

                arrPed.push(ped);
                arrVeh.push(veh);
                arrBike.push(bike);

                countVh.push({
                    hh:hh,
                    ped: ped,
                    veh: veh,
                    bike: bike,
                })

            }

            setVehicleCountTbl(countVh);
            setPedTotalCount(arrPed.reduce((sum, item) => {return sum = sum + item }, 0));
            setVehTotalCount(arrVeh.reduce((sum, item) => {return sum = sum + item }, 0));
            setBikeTotalCount(arrBike.reduce((sum, item) => {return sum = sum + item }, 0));

            // Graph bar, 2 stacks: pedestrian and vehicle / hour
            const data = {
                labels: ['00:00-01:00','01:00-02:00','02:00-03:00','03:00-04:00','04:00-05:00','05:00-06:00'
                        ,'06:00-07:00','07:00-08:00','08:00-09:00','09:00-10:00','10:00-11:00','11:00-12:00'
                        ,'12:00-13:00','13:00-14:00','14:00-15:00','15:00-16:00','16:00-17:00','17:00-18:00'
                        ,'18:00-19:00','19:00-20:00','20:00-21:00','21:00-22:00','22:00-23:00','23:00-24:00'
                        ],
                datasets: [{
                    label: 'Pedestrian',
                    data: arrPed,
                    borderColor: chartColors[1],
                    backgroundColor: chartColors[1],
                    // borderColor:'rgba(255, 99, 132, 0.2)',
                    // backgroundColor: 'rgba(255, 99, 132, 1)',
                    borderWidth: 1,
                    stack: '1'
                },
                {
                    label: 'Bike',
                    data: arrBike,
                    borderColor: chartColors[5],
                    backgroundColor: chartColors[5],
                    // borderColor:'rgba(54, 162, 235, 0.2)',
                    // backgroundColor: 'rgba(54, 162, 235, 1)',
                    borderWidth: 1,
                    stack: '2'
                },
                {
                    label: 'Vehicles',
                    data: arrVeh,
                    borderColor: chartColors[4],
                    backgroundColor: chartColors[4],
                    // borderColor:'rgba(75, 192, 192, 0.2)',
                    // backgroundColor: 'rgba(75, 192, 192, 1)',
                    borderWidth: 1,
                    stack: '3'
                }]
            }
            setVehicleCount(data);
        }

        getVehicleCount();
    // eslint-disable-next-line 
    },[counts, 
        setVehicleCountTbl,
        setPedTotalCount,
        setVehTotalCount,
        setBikeTotalCount,
        setVehicleCount]);
    // VEHICLE COUNT END

return (
    <div className="row p-2">
        <div className="col-md-12">
            <div className="row">
                <div className="col-md-12">
                    <h2 className="text-header">Vehicle Count</h2>
                    <span className="text-description small">
                    total vehicles per hour that passed a given point on the roadway
                    </span>
                </div>               
                <div className="col-md-8 text-center">
                {(isLoadingCounts) ? (
                <>
                <Spinner animation="grow" size="sm" role="status" variant="warning" />
                <span className="text-secondary">  Loading...</span>
                </>
                ): ''}
                </div>
            </div>
            <div className="pb-2 small text-right">
                Total Pedestrians <span className="text-danger">{pedTotalCount}</span> |
                Bikes <span className="text-primary">{bikeTotalCount}</span> |
                Vehicles <span className="text-success">{vehTotalCount}</span>
            </div>
            <div className="row">
                <div className="col-md-12">
                {(vehicleCount.datasets && vehicleCount.datasets.length > 0)?
                <Graph
                    title="Vehicle Count"
                    type="bar"
                    data={vehicleCount}
                    options={options}
                    site={assetName}
                />
                :''}
                </div>
                <div className="col-md-12 pt-3">
                <Table responsive hover className="small p-0 border">
                <thead>
                    <tr>
                        <th colSpan="4" className="border-right table-th">00:00 - 06:00</th>
                        <th colSpan="4" className="border-right table-th">06:00 - 12:00</th>
                        <th colSpan="4" className="border-right table-th">12:00 - 18:00</th>
                        <th colSpan="4" className="table-th">18:00 - 24:00</th>
                    </tr>
                    <tr>
                    <th className="table-th-det">Time</th>
                    <th className="table-th-det">Pedestrian</th>
                    <th className="table-th-det">Bike</th>
                    <th className="border-right table-th-det">Vehicle</th>

                    <th className="table-th-det">Time</th>
                    <th className="table-th-det">Pedestrian</th>
                    <th className="table-th-det">Bike</th>
                    <th className="border-right table-th-det">Vehicle</th>

                    <th className="table-th-det">Time</th>
                    <th className="table-th-det">Pedestrian</th>
                    <th className="table-th-det">Bike</th>
                    <th className="border-right table-th-det">Vehicle</th>

                    <th className="table-th-det">Time</th>
                    <th className="table-th-det">Pedestrian</th>
                    <th className="table-th-det">Bike</th>
                    <th className="table-th-det">Vehicle</th>
                    </tr>
                </thead>
                <tbody>
                {vehicleCountTbl.length > 0 && [...Array(6)].map((x, i) =>
                    <tr key={i} className="table-tr">
                        <td className="table-td-det text-center">{i+":00 - "+ (i+1)+":00"}</td>
                        <td className="table-td">{vehicleCountTbl[i].ped}</td>
                        <td className="table-td">{vehicleCountTbl[i].bike}</td>
                        <td className="border-right table-td">{vehicleCountTbl[i].veh}</td>

                        <td className="table-td-det text-center">{(i+6)+":00 - "+ (i+7)+":00"}</td>
                        <td className="table-td">{vehicleCountTbl[i+6].ped}</td>
                        <td className="table-td">{vehicleCountTbl[i+6].bike}</td>
                        <td className="border-right table-td">{vehicleCountTbl[i+6].veh}</td>

                        <td className="table-td-det text-center">{(i+12)+":00 - "+ (i+13)+":00"}</td>
                        <td className="table-td">{vehicleCountTbl[i+12].ped}</td>
                        <td className="table-td">{vehicleCountTbl[i+12].bike}</td>
                        <td className="border-right table-td">{vehicleCountTbl[i+12].veh}</td>

                        <td className="table-td-det text-center">{(i+18)+":00 - "+ (i+19)+":00"}</td>
                        <td className="table-td">{vehicleCountTbl[i+18].ped}</td>
                        <td className="table-td">{vehicleCountTbl[i+18].bike}</td>
                        <td className="table-td">{vehicleCountTbl[i+18].veh}</td>
                    </tr>
                )}

                </tbody>
                </Table>
                </div>
            </div>
        </div>
    </div>
)}

export default VehCounts;